import $ from "jquery";

export const Feedback = function () {
	if (!($(".feedback-page").length > 0)) return false;

	const $elms = {
		page: $(".feedback-question-page"),
		selectRole: $(".js-select-role"),
		submitFeedbackAnswers: $(".js-submit-feedback-answers"),
		sliderInput: $(".js-slider-input"),
		submitFeedbackGiver: $(".js-submit-feedback-giver"),
		feedbackGiverName: $(".js-feedback-giver-name"),
		feedbackGiverNameHidden: $("#feedback-giver-name-hidden"),
		feedbackQuestionsFilter: $(".feedback-questions__filter"),
		userQuestions: $(".user-question"),
		editFeedbackbtn: $(".js-edit-feedback"),
	};

	const type = $elms.page.attr("data-type");
	const accessToken = $elms.page.attr("data-access-token") || "";

	// Auto-expand textarea functionality
	function autoExpandTextarea(textarea) {
		// Reset height to auto to get the correct scrollHeight
		textarea.style.height = "auto";
		// Set height to scrollHeight to fit content
		textarea.style.height = textarea.scrollHeight + "px";
	}

	function feedbackLineStatus(textarea) {
		const style = window.getComputedStyle(textarea);
		const maxHeight = parseFloat(style.lineHeight) * 5
			+ parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
		textarea.style.height = "auto";
		return {
			fits: textarea.scrollHeight <= maxHeight + 1,
			reached: textarea.scrollHeight >= maxHeight - 1,
		};
	}

	// Check if feedback giver name exists in session storage
	function checkFeedbackGiverName() {
		const storedName = sessionStorage.getItem("feedback_giver_name");
		if (storedName && storedName.trim() !== "") {
			// Name exists, show feedback questions
			$elms.feedbackGiverName.val(storedName);
			$elms.feedbackGiverNameHidden.val(storedName);
			$elms.page.attr("data-feedback-giver-name", storedName);
			// Auto-expand textarea if it's a textarea
			if (
				$elms.feedbackGiverName.is("textarea") &&
				$elms.feedbackGiverName.length
			) {
				autoExpandTextarea($elms.feedbackGiverName[0]);
			}
			showFeedbackQuestions();
		}
	}

	// Show feedback questions after name is submitted
	function showFeedbackQuestions() {
		// $elms.feedbackQuestionsFilter.show();
		$elms.userQuestions.show();

		// Lock the name input and hide the completed name step
		$elms.feedbackGiverName.prop("readonly", true);
		$elms.feedbackGiverName.addClass("is-submitted");
		$elms.submitFeedbackGiver.hide();
		$elms.submitFeedbackGiver.addClass("is-submitted");

		// Store original values for all feedback textareas
		$(".js-feedback-input").each(function () {
			const $textarea = $(this);
			if ($textarea.is("textarea")) {
				$textarea.data("original-value", $textarea.val());
			}
		});

		// Check all submit buttons now that the feedback giver name is set
		$elms.submitFeedbackAnswers.each(function () {
			checkMandatoryQuestions($(this));
		});
	}

	// Handle feedback giver name submission
	$elms.submitFeedbackGiver.on("click", function () {
		const $this = $(this);
		// If this is an <a> (no native disabled behavior) or already submitted, ignore clicks.
		if (
			$this.hasClass("is-loading") ||
			$this.hasClass("is-submitted") ||
			$this.prop("disabled")
		)
			return;

		const name = $elms.feedbackGiverName.val().trim();
		if (!name) {
			alert("Please enter your name first.");
			$elms.feedbackGiverName.focus();
			return;
		}

		if (name.length < 2) {
			alert("Please enter a valid name (at least 2 characters).");
			$elms.feedbackGiverName.focus();
			return;
		}

		$this.hide();
		$this.addClass("is-loading");

		// Save to session storage
		sessionStorage.setItem("feedback_giver_name", name);

		// Update hidden input and data attribute
		$elms.feedbackGiverNameHidden.val(name);
		$elms.page.attr("data-feedback-giver-name", name);

		// Show feedback questions
		showFeedbackQuestions();

		// Keep the name step hidden after submission.
		$this.removeClass("is-loading");
	});

	// Allow submission by pressing Enter in the name input
	$elms.feedbackGiverName.on("keypress", function (event) {
		if (event.key === "Enter") {
			$elms.submitFeedbackGiver.trigger("click");
		}
	});


	if ($elms.feedbackGiverName.length && $elms.feedbackGiverName.is("textarea")) {

		autoExpandTextarea($elms.feedbackGiverName[0]);


		$elms.feedbackGiverName.on("input", function () {
			autoExpandTextarea(this);
		});

	
		$elms.feedbackGiverName.on("paste", function () {
			const $this = $(this);
			setTimeout(function () {
				autoExpandTextarea($this[0]);
			}, 10);
		});
	}

	const $feedbackInputs = $(".js-feedback-input");
	if ($feedbackInputs.length) {
		$feedbackInputs.each(function () {
			const $textarea = $(this);
			
			if ($textarea.is("textarea")) {
				const $limitMessage = $textarea.closest(".user-question__feedback").find(".js-feedback-limit");
				// Store the original value
				$textarea.data("original-value", $textarea.val());
				let lastAcceptedValue = $textarea.val();
				const initialStatus = feedbackLineStatus(this);
				let lastAcceptedFits = initialStatus.fits;
				$limitMessage.prop("hidden", this.readOnly || !initialStatus.reached);
				
				// Set initial height
				autoExpandTextarea($textarea[0]);

				// Auto-expand and check validation on input
				$textarea.on("input", function () {
					const cursor = this.selectionStart;
					const status = feedbackLineStatus(this);
					const rejected = !status.fits && (lastAcceptedFits || this.value.length >= lastAcceptedValue.length);
					if (rejected) {
						this.value = lastAcceptedValue;
						this.setSelectionRange(Math.min(cursor, this.value.length), Math.min(cursor, this.value.length));
					} else {
						lastAcceptedValue = this.value;
						lastAcceptedFits = status.fits;
					}
					$limitMessage.prop("hidden", this.readOnly || !(status.reached || rejected));
					autoExpandTextarea(this);
					
					// Check if submit button should be enabled/disabled
					const $participantContainer = $(this).closest(".user-question");
					const $submitButton = $participantContainer.find(".js-submit-feedback-answers");
					checkMandatoryQuestions($submitButton);
				});

				// Auto-expand on paste
				$textarea.on("paste", function () {
					const $this = $(this);
					setTimeout(function () {
						autoExpandTextarea($this[0]);
						
						// Check if submit button should be enabled/disabled
						const $participantContainer = $this.closest(".user-question");
						const $submitButton = $participantContainer.find(".js-submit-feedback-answers");
						checkMandatoryQuestions($submitButton);
					}, 10);
				});
			}
		});
	}

	// Check feedback giver name on page load
	checkFeedbackGiverName();

	// Function to clear feedback giver name and reset form
	function clearFeedbackGiverName() {
		sessionStorage.removeItem("feedback_giver_name");
		$elms.feedbackGiverName.val("");
		$elms.feedbackGiverNameHidden.val("");
		$elms.page.attr("data-feedback-giver-name", "");
		$elms.feedbackGiverName.prop("readonly", false);
		$elms.feedbackGiverName.removeClass("is-submitted");
		$elms.submitFeedbackGiver.show();
		$elms.submitFeedbackGiver.removeClass("is-submitted");
		$elms.feedbackQuestionsFilter.hide();
		$elms.userQuestions.hide();
	}

	// Add double-click functionality to change name (for development/testing)
	$elms.feedbackGiverName.on("dblclick", function () {
		if ($(this).prop("readonly")) {
			if (
				confirm(
					"Do you want to change your name? This will reset all feedback questions.",
				)
			) {
				clearFeedbackGiverName();
			}
		}
	});

	// Handle page refresh - check if we need to reset
	$(window).on("beforeunload", function () {
		// Keep the name in session storage for page refresh
	});

	$elms.selectRole.on("click", function () {
		const $this = $(this);
		const target = $this.attr("data-target");

		$this.addClass("is-active");
		$this.siblings().removeClass("is-active");

		const $userQuestions = $(".user-question");
		const $container = $(".feedback-questions");

		// Store current scroll position
		const scrollTop = $(window).scrollTop();

		if (target === "all") {
			// Set container height to prevent jumping
			const currentHeight = $container.height();
			$container.css("min-height", currentHeight + "px");

			$userQuestions.stop().fadeOut(200);
			setTimeout(() => {
				$userQuestions.fadeIn(200, function () {
					// Remove min-height after animation completes
					$container.css("min-height", "");
					// Restore scroll position
					$(window).scrollTop(scrollTop);
				});
			}, 250);
		} else {
			// Set container height to prevent jumping
			const currentHeight = $container.height();
			$container.css("min-height", currentHeight + "px");

			$userQuestions.stop().fadeOut(200);
			setTimeout(() => {
				const $matchingQuestions = $userQuestions.filter(
					`[data-role-id="${target}"]`,
				);
				$matchingQuestions.fadeIn(200, function () {
					// Remove min-height after animation completes
					$container.css("min-height", "");
					// Restore scroll position
					$(window).scrollTop(scrollTop);
				});
			}, 250);
		}
	});

	$elms.sliderInput.on("input", function () {
		const $this = $(this);
		const questionId = $this.data("question-id");
		const value = $this.val();
		const feedbacks = window.CFG.data.question_feedback?.find(
			(item) => item.ID === questionId,
		);

		if (!feedbacks || !feedbacks.feedback) return;

		const feedback = feedbacks.feedback?.find(
			(f) =>
				parseInt(value) >= parseInt(f.range_min) &&
				parseInt(value) <= parseInt(f.range_max),
		);

		const $sliderFeedback = $this
			.closest(".slider")
			.siblings(".slider__feedback");

		if (feedback) {
			$sliderFeedback.text(feedback.feedback);
			$sliderFeedback.fadeIn(300);
		} else {
			$sliderFeedback.fadeOut(200);
		}
	});

	$elms.editFeedbackbtn.on("click", function () {
		const $this = $(this);

		const $participantContainer = $this.closest(".user-question");
		$participantContainer.find(".js-slider-input").prop("disabled", false);
		$participantContainer.find(".slider").removeClass("is-submitted");

		$this.removeClass("is-submitted");

		$elms.submitFeedbackAnswers.removeClass("is-submitted");
		
		const $feedbackTextarea = $participantContainer.find(".js-feedback-input");
		$feedbackTextarea
			.removeClass("is-submitted")
			.prop("readonly", false);
		
		// Update original value to current value (user needs to make changes to submit again)
		$feedbackTextarea.data("original-value", $feedbackTextarea.val());
		
		// Check if submit button should be enabled (will be disabled since no changes yet)
		const $submitButton = $participantContainer.find(".js-submit-feedback-answers");
		$submitButton.attr("data-is-submitted", "0");
		checkMandatoryQuestions($submitButton);
		
		$this
			.siblings(".user-question__feedback-confirmation")
			.removeClass("is-submitted");
	});

	$elms.submitFeedbackAnswers.on("click", function () {
		const $this = $(this);
		if ($this.hasClass("is-loading")) return;

		// Check if feedback giver name exists
		const feedbackGiverName = sessionStorage.getItem("feedback_giver_name");
		if (!feedbackGiverName || feedbackGiverName.trim() === "") {
			alert("Please submit your name first before submitting feedback.");
			return;
		}

		$this.prop("disabled", true);
		$this.addClass("is-loading");

		const $participantContainer = $this.closest(".user-question");
		const $participantSliders = $participantContainer.find(".js-slider-input");

		const answers = [];
		$participantSliders.each(function () {
			const $this = $(this);
			const questionId = $this.attr("data-question-id");
			const value = $this.val();
			answers.push({ questionId, value: parseInt(value) });
		});

		if ($participantContainer.find(".js-feedback-input").val()) {
			answers.push({
				questionId: "feedback-text",
				value: $participantContainer.find(".js-feedback-input").val(),
			});
		}

		const phase = $elms.page.attr("data-phase");

		const data = {
			phase: parseInt(phase),
			type: type,
			answers,
			user_id: $this.attr("data-user-id"),
			feedback_giver_name: feedbackGiverName,
			access_token: $this.attr("data-access-token") || accessToken,
			nonce: window.CFG.nonce,
			action: "feedback-answer",
		};

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: data,
			success: function (response) {
				if (!response.success) {
					console.error(response.data.message || "Something went wrong");
					$this.prop("disabled", false);
				} else {
					$this.prop("disabled", true);

					// Disable all sliders and inputs in this participant's form after successful submission
					const $participantContainer = $this.closest(".user-question");
					$participantContainer.find(".js-slider-input").prop("disabled", true);
					$participantContainer
						.find(".js-feedback-input")
						.prop("readonly", true);
					$this
						.siblings(".user-question__feedback-confirmation")
						.addClass("is-success");

					setTimeout(function () {
						$this
							.siblings(".user-question__feedback-confirmation")
							.removeClass("is-success")
							.addClass("is-submitted");

						const $participantContainer = $this.closest(".user-question");
						$participantContainer
							.find(".js-slider-input")
							.prop("disabled", true);
						$participantContainer.find(".slider").addClass("is-submitted");

						$this.addClass("is-submitted");

						$participantContainer
							.find(".js-submit-feedback-answers")
							.prop("disabled", true)
							.addClass("is-submitted");
						$participantContainer
							.find(".js-edit-feedback")
							.addClass("is-submitted");
						$participantContainer
							.find(".js-feedback-input")
							.addClass("is-submitted")
							.prop("readonly", true);
						$this
							.siblings(".user-question__feedback-confirmation")
							.addClass("is-submitted");
					}, 2000);
				}
			},
			error: function (error) {
				$this.prop("disabled", false);
				console.error(error);
			},
			complete: function () {
				$this.removeClass("is-loading");
			},
		});
	});

	function checkMandatoryQuestions($submitButton) {
		if ($submitButton.attr("data-is-submitted") === "1") return;

		// Check if feedback giver name exists
		const feedbackGiverName = sessionStorage.getItem("feedback_giver_name");
		if (!feedbackGiverName || feedbackGiverName.trim() === "") {
			$submitButton.prop("disabled", true);
			return;
		}

		// Get the specific participant's question container
		const $participantContainer = $submitButton.closest(".user-question");
		const $feedbackTextarea = $participantContainer.find(".js-feedback-input");

		// Check if feedback textarea has content
		const feedbackValue = $feedbackTextarea.val().trim();
		const originalValue = ($feedbackTextarea.data("original-value") || "").trim();

		// Disable button if textarea is empty or hasn't changed
		if (feedbackValue === "" || feedbackValue === originalValue) {
			$submitButton.prop("disabled", true);
			return;
		}

		// Enable the button if all conditions are met
		$submitButton.prop("disabled", false);

		// Old code for checking slider questions (commented out)
		/*
		const $participantSliders = $participantContainer.find(".js-slider-input");

		// Check mandatory questions for this specific participant
		const $unansweredMandatoryQuestions = $participantSliders.filter(
			function () {
				const $slider = $(this);
				return (
					$slider.attr("is-mandatory") === "1" &&
					$slider.attr("is-activated") === "0"
				);
			},
		);

		// Enable/disable this specific submit button
		$submitButton.prop("disabled", $unansweredMandatoryQuestions.length > 0);
		*/
	}

	// Check all submit buttons initially
	$elms.submitFeedbackAnswers.each(function () {
		checkMandatoryQuestions($(this));
	});

	// Listen for slider changes to update specific submit buttons
	$elms.sliderInput.on("input", function () {
		const $slider = $(this);
		const $participantContainer = $slider.closest(".user-question");
		const $submitButton = $participantContainer.find(
			".js-submit-feedback-answers",
		);

		// Update the specific submit button when slider changes
		checkMandatoryQuestions($submitButton);
	});

	function initializeSliders() {
		const sliders = document.querySelectorAll(".slider");

		// Function to convert hex or rgb string to RGB array
		function colorToRGB(color) {
			// Create a temporary div to use the browser's color parsing
			const temp = document.createElement("div");
			temp.style.color = color;
			document.body.appendChild(temp);
			const computedColor = window.getComputedStyle(temp).color;
			document.body.removeChild(temp);

			// Extract RGB values using regex
			const rgb = computedColor.match(/\d+/g).map(Number);
			return rgb;
		}

		sliders.forEach((sliderContainer) => {
			const sliderInput = sliderContainer.querySelector(".slider__input");
			const valueDisplay = sliderContainer.querySelector(
				".slider__value-display",
			);
			const customThumb = sliderContainer.querySelector(".slider__thumb");
			const thumbIcon = sliderContainer.querySelector(".slider__thumb svg");

			// Track if slider has ever been moved from 0
			let hasBeenActivated = false;

			function updateSlider(value) {
				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);

				valueDisplay.textContent = value;

				const percent = ((value - min) / (max - min)) * 100;

				const minThumbSize = 1.25; // 20px converted to em (20/16)
				const maxThumbSize = 3.125; // 50px converted to em (50/16)
				const thumbSize =
					minThumbSize + (percent / 100) * (maxThumbSize - minThumbSize);
				customThumb.style.width = `${thumbSize}em`;
				customThumb.style.height = `${thumbSize}em`;

				customThumb.style.left = `calc(${percent}% - ${thumbSize * (percent / 100 - 0.5)}em)`;

				// Mark as activated if value > 0
				if (value > 0) {
					hasBeenActivated = true;
					sliderInput.setAttribute("is-activated", "1");
				}

				// Apply colors if slider has been activated OR is currently > 0
				if (hasBeenActivated || value > 0) {
					// Activate colored track
					const track = sliderContainer.querySelector(".slider__track");
					const gradientLeft = track.getAttribute("data-gradient-left");
					const gradientRight = track.getAttribute("data-gradient-right");
					// track.style.background = `linear-gradient(to right, ${gradientLeft}, ${gradientRight})`;

					const startColor = colorToRGB(gradientLeft);
					const endColor = colorToRGB(gradientRight);
					const color = startColor.map((start, i) => {
						const end = endColor[i];
						return Math.round(start + (end - start) * (percent / 100));
					});

					// Show/hide icon based on value
					thumbIcon.style.opacity = value <= 3 ? "0" : "1";

					valueDisplay.style.color = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
					customThumb.style.backgroundColor = `rgb(144, 224, 144)`;
					track.style.background = `#f17f3c`;
				} else {
					// Keep grey state when slider has never been activated
					const track = sliderContainer.querySelector(".slider__track");
					track.style.background = "#cccccc";
					thumbIcon.style.opacity = "0";
					valueDisplay.style.color = "#999999";
					customThumb.style.backgroundColor = "#999999";
				}
			}

			// Add event listener for this specific slider
			sliderInput.addEventListener("input", (event) => {
				updateSlider(event.target.value);

				// Find the submit button for this participant and check mandatory questions
				const $slider = $(sliderInput);
				const $participantContainer = $slider.closest(".user-question");
				const $submitButton = $participantContainer.find(
					".js-submit-feedback-answers",
				);
				checkMandatoryQuestions($submitButton);
			});

			// Add drag functionality to custom thumb
			let isDragging = false;

			function handleThumbDrag(event) {
				if (!isDragging) return;

				event.preventDefault();

				const sliderRect = sliderContainer
					.querySelector(".slider__wrapper")
					.getBoundingClientRect();
				const clientX = event.type.includes("touch")
					? event.touches[0].clientX
					: event.clientX;
				const percent = Math.max(
					0,
					Math.min(100, ((clientX - sliderRect.left) / sliderRect.width) * 100),
				);

				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);
				const value = Math.round(min + (percent / 100) * (max - min));

				sliderInput.value = value;
				updateSlider(value);

				// Trigger input event to call checkMandatoryQuestions()
				const inputEvent = new Event("input", { bubbles: true });
				sliderInput.dispatchEvent(inputEvent);
			}

			// Mouse events for custom thumb
			customThumb.addEventListener("mousedown", (event) => {
				// Don't allow dragging if slider is disabled
				if (sliderInput.disabled) return;

				isDragging = true;
				event.preventDefault();
				document.addEventListener("mousemove", handleThumbDrag);
				document.addEventListener("mouseup", () => {
					isDragging = false;
					document.removeEventListener("mousemove", handleThumbDrag);
				});
			});

			// Touch events for mobile
			customThumb.addEventListener("touchstart", (event) => {
				// Don't allow dragging if slider is disabled
				if (sliderInput.disabled) return;

				isDragging = true;
				event.preventDefault();
				document.addEventListener("touchmove", handleThumbDrag, {
					passive: false,
				});
				document.addEventListener("touchend", () => {
					isDragging = false;
					document.removeEventListener("touchmove", handleThumbDrag);
				});
			});

			// Add click functionality to slider track
			const sliderWrapper = sliderContainer.querySelector(".slider__wrapper");
			sliderWrapper.addEventListener("click", (event) => {
				// Don't allow clicking if slider is disabled
				if (sliderInput.disabled) return;

				// Don't trigger if clicking on the thumb itself
				if (event.target === customThumb || customThumb.contains(event.target))
					return;

				const sliderRect = sliderWrapper.getBoundingClientRect();
				const percent = Math.max(
					0,
					Math.min(
						100,
						((event.clientX - sliderRect.left) / sliderRect.width) * 100,
					),
				);

				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);
				const value = Math.round(min + (percent / 100) * (max - min));

				sliderInput.value = value;
				updateSlider(value);

				// Trigger input event to call checkMandatoryQuestions()
				const inputEvent = new Event("input", { bubbles: true });
				sliderInput.dispatchEvent(inputEvent);
			});

			// Initialize with current value
			updateSlider(sliderInput.value);

			// Add disabled state styling
			if (sliderInput.disabled) {
				customThumb.style.cursor = "not-allowed";
			}
		});
	}

	initializeSliders();
};
